import * as Types from '@frameio/graphql-client/generated/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import gql from 'graphql-tag';
import { ProjectAppliedPolicies } from '../../fragments/generated/ProjectAppliedPolicies';

import { useQuery, useLazyQuery, useMutation, useFragment, useSubscription } from '@apollo/client';
import type { QueryHookOptions, LazyQueryHookOptions, MutationHookOptions, SubscriptionHookOptions, UseFragmentOptions } from '@apollo/client';

export type GetProjectAppliedPoliciesQueryVariables = Types.Exact<{
  projectId: Types.Scalars['ID']['input'];
}>;


export type GetProjectAppliedPoliciesQuery = { __typename?: 'Query', account?: { __typename?: 'Account', id: string, project?: { __typename?: 'Project', id: string, appliedResourceControlPolicies?: { __typename?: 'ResourceControlPolicies', downloads?: { __typename?: 'DownloadsSettings', shareDownloadingEnabled?: boolean | null } | null, shareAccess?: { __typename?: 'ShareAccessSettings', default?: Types.ShareAccess | null, minimum?: Types.ShareAccess | null } | null, sharePassphrase?: { __typename?: 'SharePassphraseSettings', required?: boolean | null } | null } | null } | null } | null };


export const GetProjectAppliedPolicies = /*#__PURE__*/ gql`
    query GetProjectAppliedPolicies($projectId: ID!) {
  account(by: {projectId: $projectId}) {
    id
    project(id: $projectId) {
      ...ProjectAppliedPolicies
    }
  }
}
    ${ProjectAppliedPolicies}` as unknown as DocumentNode<GetProjectAppliedPoliciesQuery, GetProjectAppliedPoliciesQueryVariables>;

          

          export const useGetProjectAppliedPoliciesQuery = (options?:QueryHookOptions<GetProjectAppliedPoliciesQuery, GetProjectAppliedPoliciesQueryVariables>) => useQuery(GetProjectAppliedPolicies, options);

          

          export type GetProjectAppliedPoliciesQueryOptions = QueryHookOptions<GetProjectAppliedPoliciesQuery, GetProjectAppliedPoliciesQueryVariables>;

          

          export const useGetProjectAppliedPoliciesLazyQuery = (options?:LazyQueryHookOptions<GetProjectAppliedPoliciesQuery, GetProjectAppliedPoliciesQueryVariables>) => useLazyQuery(GetProjectAppliedPolicies, options);

          

          export type GetProjectAppliedPoliciesQueryResult = ReturnType<typeof useGetProjectAppliedPoliciesQuery>;

          
